export default __webpack_public_path__ + "static/media/computer-vision.ce710c57.png";